module.exports = __webpack_public_path__ + "static/media/bg-login-signup_tn.a3c77ddb.jpg";